import { render, staticRenderFns } from "./MessageAddUsersRole.vue?vue&type=template&id=5037fb84"
import script from "./MessageAddUsersRole.vue?vue&type=script&lang=js"
export * from "./MessageAddUsersRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports